import {ActionList, ActionMenu, RelativeTime} from '@primer/react'
import type {SinceSelector} from '../../../routes/route-payload-types'
import {SinceSource} from '../../../routes/route-payload-types'

const sinceSourceDescriptionMap: Record<SinceSource, string> = {
  [SinceSource.Created]: 'Since this pull request was created',
  [SinceSource.LastReview]: 'Since your last review',
  [SinceSource.LastInteracted]: 'Since you last interacted',
  [SinceSource.ReadyForReview]: 'Since marked ready for review',
}

type ActivitySelectorProps = {
  selectors: SinceSelector[]
  selection: SinceSelector | null
  onSelect: (newSelection: SinceSelector) => void
}

/** Selector dropdown for the Activity section — rendered in the CollapsiblePanel header */
export function ActivitySelector({selectors, selection, onSelect}: ActivitySelectorProps) {
  if (!selection || selectors.length === 0) return null

  return (
    <ActionMenu>
      <ActionMenu.Button size="small" variant="invisible">
        {sinceSourceDescriptionMap[selection?.source ?? '']}
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          {selectors.map(selector => (
            <ActionList.Item
              key={selector.source}
              selected={selector.source === selection?.source}
              onSelect={() => onSelect(selector)}
            >
              {sinceSourceDescriptionMap[selector.source]}
              <ActionList.Description>
                <RelativeTime date={new Date(selector.timestamp)} />
              </ActionList.Description>
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
